import { cx } from '@/lib/cx'
import styles from './panel.module.css'

interface SessionCounterProps {
  /** Sesiones acumuladas (el Crew Bonus cuenta doble). */
  credits: number
  target: number
  sessionsPerWeek: number
  weeks: number
}

/** Los dorsales: una casilla por sesión, se encienden al completarlas. */
export function SessionCounter({ credits, target, sessionsPerWeek, weeks }: SessionCounterProps) {
  const filled = Math.min(credits, target)

  return (
    <section className={styles.counter} aria-label="Sesiones completadas">
      <div className={styles.counterHead}>
        <span className={styles.counterLabel}>
          Sesiones completadas
          <br />
          {sessionsPerWeek} por semana · {weeks === 1 ? '1 semana' : `${weeks} semanas`}
        </span>
        <span className={styles.counterNumber}>
          {filled}
          <i>/{target}</i>
        </span>
      </div>
      <div className={styles.bibs}>
        {Array.from({ length: target }, (_, index) => (
          <div key={index} className={cx(styles.bib, index < filled && styles.bibOn)}>
            {String(index + 1).padStart(2, '0')}
          </div>
        ))}
      </div>
    </section>
  )
}
